function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "popout_svg__a",
  d: "M14.827 1.9h-3.16a.9.9 0 110-1.8H17a.9.9 0 01.9.9v5.333a.9.9 0 11-1.8 0v-3.16l-8.241 8.241a.9.9 0 01-1.273-1.273L14.827 1.9zm-1.394 7.989a.9.9 0 011.8 0v5.333a2.678 2.678 0 01-2.677 2.678H2.778A2.678 2.678 0 01.1 15.222V5.444a2.678 2.678 0 012.678-2.677H8.11a.9.9 0 110 1.8H2.778a.878.878 0 00-.878.877v9.778c0 .485.393.878.878.878h9.778a.878.878 0 00.877-.878V9.89z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(3 3)"
}, React.createElement("mask", {
  id: "popout_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#popout_svg__a"
})), React.createElement("use", {
  fill: "#000",
  fillRule: "nonzero",
  xlinkHref: "#popout_svg__a"
}), React.createElement("g", {
  fill: "#000",
  mask: "url(#popout_svg__b)"
}, React.createElement("path", {
  d: "M-3-3h24v24H-3z"
})));

var SvgPopout = function SvgPopout(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/popout.a4357ffe.svg";
export { SvgPopout as ReactComponent };